<template>
    <div>
        <flash-alert :message="errormessage" v-if="errormessage"></flash-alert>
        <div class="bg-white border-bottom pt-4 pb-4">
            <div class="container">
                <div class="row">
                    <div class="col-4">
                        <a :href="'/judging'" class="btn">
                            <caret_left></caret_left> Back to List
                        </a>
                    </div>
                    <div class="col-8 d-flex align-items-center justify-content-end">
                        <div class="d-flex justify-content-end align-items-center">
                            <div class="checkout-checkbox-wrapper pull-right ml-4 position-relative" v-if="max_selections != num_selected_to_update || (selectedValue)">
                                <input v-model="selectedValue" type="checkbox" :id="'order_ids_'" class="checkbox hide-me" name="order_ids[]" @click="saveSelection($event)">
                                <label class="box-checking position-absolute nested-checkbox-for-judges" :for="'order_ids_'"></label>
                                <label class="btn btn-for-judges" :for="'order_ids_'" v-if="!disableSelectionBox">Select</label>
                                <label class="btn btn-for-judges disabled" v-else>Select</label>
                            </div>
                            <div class="checkout-checkbox-wrapper pull-right ml-4 position-relative" v-if="(max_selections == num_selected_to_update) && (!selectedValue)">
                                <label class="box-checking position-absolute nested-checkbox-for-judges" :for="'order_ids_'"></label>
                                <label class="btn no-hover btn-for-judges" :for="'order_ids_'" v-if="!disableSelectionBox">Select</label>
                                <label class="btn btn-for-judges disabled" v-else>Select</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-4 note-area-wrapper bg-light">
            <div class="container">
                <div class="col-10 offset-1 position-relative">
                    <label class="textarea-label" :for="'notearea'">Notes:</label>
                    <textarea @focusin="disableSelectionBox = true;" @focusout="saveSelection($event)" v-model="note" rows=3 class="form-control" :id="'notearea'"></textarea>
                    <div class="position-absolute textarea-description">
                        Keep track of your thoughts on each submission. Only you will be able to see these notes.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import caret_left from "./icons/caret_left";
    export default {
        name: "OrderJudging",
        components: {caret_left},
        props: ['actionurl', 'note_loaded', 'selection_value_loaded', 'num_selected', 'max_selections'],
        data() {
            return {
                note: '',
                originalNote: '',
                selectedValue: '',
                num_selected_to_update: this.num_selected,
                errormessage: '',
                savingData: false,
                disableSelectionBox: false,
            }
        },
        created: function() {
            this.note = this.note_loaded;
            this.originalNote = this.note_loaded;
            this.selectedValue = Number(this.selection_value_loaded);
            this.$emit('judge_num_selections', this.num_selected)
        },
        methods:{
            saveSelection: function($event) {
                let app = this;
                let selectionVal;

                if(app.savingData) {
                    return;
                }
                app.savingData = true;

                if($event.target.tagName == 'TEXTAREA') {
                    // Checkbox did not initial the save so grab the value from the existing data
                    selectionVal = app.selectedValue;
                } else {
                    // We checked the checkbox, figure out if we're a 0 or 1.
                    if ($event.target.checked) {
                        selectionVal = 1;
                    } else {
                        selectionVal = 0;
                    }
                }

                axios.post(app.actionurl, {
                    selection: selectionVal,
                    notes: app.note
                })
                .then(res => {
                    app.originalNote = app.note
                    this.$emit('judge_num_selections', res.data.num_selections)
                    app.savingData = false;
                    app.disableSelectionBox = false;
                }).catch(err => {
                    this.errors = 'Error contacting the server : ';
                    this.errors += err;
                    this.errormessage = err.response.data;
                    // Unsetting checkbox as the error will not set the checkbox
                    $event.target.checked = false;
                    app.savingData = false;
                    app.disableSelectionBox = false;
                });
            },
            cancelNote: function() {
                let app = this;
                app.note = app.originalNote
            },
        }
    }
</script>
